// Space Control Icon.
export const SpacingControlIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 24 }
		height={ 24 }
		fill="none"
	>
		<path
			fill="#2F2F2F"
			d="M8.4 16.7h.7l-1.6 3.5.9.4 3.9-8.5H15v-1.5h-2l1.3-2.8h1.3c2 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7H14v1.5h1.6c2.9 0 5.2-2.3 5.2-5.2 0-2.9-2.3-5.2-5.2-5.2H15l1.4-3.2-.9-.4-5.7 12.5H8.4c-2 0-3.7-1.7-3.7-3.7s1.7-3.7 3.7-3.7H10V6.3H8.4c-2.9 0-5.2 2.3-5.2 5.2 0 2.9 2.4 5.2 5.2 5.2Z"
		/>
	</svg>
);
// Space Control Icon.
export const SpacingControlActiveIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 24 }
		height={ 24 }
		fill="none"
	>
		<path
			fill="#fff"
			d="M8.4 16.8H10v-1.5H8.4c-2 0-3.7-1.7-3.7-3.7s1.7-3.7 3.7-3.7H10V6.4H8.4c-2.8 0-5.2 2.3-5.2 5.2 0 2.9 2.3 5.2 5.2 5.2Zm10.9-5.2c0 2-1.7 3.7-3.7 3.7H14v1.5h1.6c2.9 0 5.2-2.3 5.2-5.2 0-2.9-2.3-5.2-5.2-5.2H14v1.5h1.6c2 0 3.7 1.7 3.7 3.7Zm-4.6-.9H9.4v1.5h5.3v-1.5Z"
		/>
	</svg>
);
